import React from "react";
import {
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import { Link } from "react-router-dom";


export default function Topbar() {

  function handleSocialMedia(){
    alert("Social Media Link Creation is in progress !");
  }

  return (
    <div className="topbar">
      <div className="contact-info">
        <span><i className="fas fa-phone-alt"></i></span>
        <span><i className="fas fa-envelope"></i>INFO@DIGIHEALTECHNOLOGIES.COM</span>
      </div>
      <div className="social-links">
        <Link to="#instagram" className="instagram" onClick={handleSocialMedia}><FaInstagram /></Link>
        <Link to="#twitter" className="twitter" onClick={handleSocialMedia}><FaTwitter /></Link>
        <Link to="#linkedin" className="linkedin" onClick={handleSocialMedia}><FaLinkedinIn /></Link>
      </div>
    </div>
  );
}
